<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Crescimento no mercado europeu</h2>
          <p>
            JBS realiza a aquisição da empresa italiana de embutidos
            <strong>Rigamonti</strong>
          </p>
          <img
            src="../assets/img/2011/2011-1.jpg"
            alt=""
            @click="showMultiple(0)"
          />
        </div>
        <div class="formato__warpper__item--image">
          <img
            src="../assets/img/2011/2011-2.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2011/11/30/g/20111130-43142-nac-64-eco-x4-not-xhkghae.jpg'
              )
            "
            class="fistItem"
          />
          <img
            src="../assets/img/2011/2011-3.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2012/06/19/g/20120619-43344-spo-28-eco-b15-not-ewghhee.jpg'
              )
            "
            class="secondItem"
          />
        </div>
        <div class="formato__warpper__item--black">
          <h2>A era das ‘superpadarias’ Instagram</h2>
          <p>
            Acostumadas por décadas a vender pães, roscas e doces, as padarias
            passaram por uma revolução nos anos 2000: tornaram-se não só lugares
            para venda de alimentos panificados, mas também de refeições.
          </p>
          <img
            src="../assets/img/2011/2011-4.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2014/04/30/g/20140430-44024-spo-103-eco-x5-not-eeqahgq.jpg'
              )
            "
            class="secondItem"
          />
          <span
            ><i class="icon-eye"></i
            ><strong>clique nas imagens para ampliar</strong></span
          >
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    showMultiple(index) {
      this.imgsRef = [
        {
          src: require("@/assets/img/2011/2011-1-full.jpg"),
          title: "2011 - Aquisição da empresa italiana de embutidos Rigamonti.",
        },
      ];
      this.indexRef = index; // index of imgList
      this.onShow();
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 375px 1fr 300px;
    gap: 40px;
    justify-content: space-between;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;
    img {
      max-width: 100%;
      transition: 0.3s ease-in-out;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      &--image {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        @include media("<=desktop") {
          padding: 0 20px;
        }
        span {
          position: absolute;
          left: 0px;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
      }
      h2 {
        color: color(primary);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cText);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }

      &--black {
        @include media("<=desktop") {
          padding: 40px 20px;
          background: color(cBlue);
        }
        span {
          display: block;
          width: 65px;
          color: color(cBlue4);

          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cWhite);
          }
          i {
            display: block;
            font-size: 1.3rem;
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          margin-block: 10px;
        }
        blockquote {
          color: color(cBlack);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          margin: 10px 0;
          position: relative;
          span {
            width: initial;
            display: inline;
            font-weight: 400;
          }
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: color(cBlue);
      width: 45%;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        display: none;
      }
    }
  }
}
</style>
